import React from 'react';
import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Service from '../Service/http';
import TimeAgo from 'react-timeago';
import { FadeLoader } from "react-spinners";
import './TimeLine.css';

const UserHandleHistory = () => {
    let [sitesOptions, setSitesOptions] = useState([]);
    let [loading, SetLoading] = useState(false);
    let [profileData, setProfileData] = useState({});
    let [historyData, setHistoryData] = useState([]);
    const navigate = useNavigate();
    const { userId, site_name } = useParams();
    const [selectedOption, setSelectedOption] = useState(site_name);

    const handleOptionSelect = (option) => {
        setSelectedOption(option);
        navigate(`/user/${userId}/${option}`);
    };
    const service = new Service();

    useEffect(() => {
        SetLoading(true)
        setHistoryData([])
        service
            .get('api/sites/options')
            .then((json) => {
                setSitesOptions(json.filter((site) => site !== 'dont_show_criteria'));

                service
                    .get(`api/userhandle/history/${userId}/${site_name}`)
                    .then((json2) => {
                        if(json2.data.length>0)setHistoryData(json2?.data);

                        setProfileData(json2?.userData);
                        SetLoading(false)
                    })
                    .catch((error) => {
                        console.log(error);
                        SetLoading(false)
                    });


            })
            .catch((error) => {
                console.log(error);
                SetLoading(false)
            });
    }, [site_name]);

    return (
        <>
            <div className="text-center h5 font-monospace text-primary mt-2" style={{ display: "flex", justifyContent: "space-between" ,margin:"1%"}}>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item" style={{ cursor: "pointer" }}><a onClick={() => navigate("/coding/profile/" + userId)}>Coding Profile</a></li>
                        <li className="breadcrumb-item active" aria-current="page">Handle History</li>
                    </ol>
                </nav>
            </div>
            {!loading ? <div style={{ margin: "1%" }}>
                <div className="row">
                    <div className="col-12 col-md-4 col-lg-3 mb-3">
                        {/* Profile Card */}
                        <div className="card">
                            <div className="card-body">
                                <div className="card-text">
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }}>
                                        {/* Profile picture */}
                                        {profileData.avatar ? (
                                            <img
                                                src={profileData.avatar}
                                                alt="Profile Picture"
                                                style={{
                                                    width: '150px',
                                                    height: '150px',
                                                    borderRadius: '50%',
                                                    objectFit: 'cover',
                                                }}
                                            />
                                        ) : (
                                            <div
                                                style={{
                                                    width: '150px',
                                                    height: '150px',
                                                    borderRadius: '50%',
                                                    objectFit: 'cover',
                                                    backgroundColor: 'gray',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    color: 'white',
                                                    fontWeight: 'bold',
                                                }}
                                            >
                                                No Profile Pic Found
                                            </div>
                                        )}
                                    </div>
                                    <hr style={{ border: '1px solid black', marginTop: '10px' }} />
                                    <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                            {/* Profile details */}
                                            <h4 style={{ fontStyle: 'italic', fontWeight: 'bold', color: 'gray' }}>{profileData.name}</h4>
                                            <p style={{ fontStyle: 'italic', fontWeight: 'bold', color: 'gray' }}>Email: {profileData.email}</p>
                                            {profileData?.roll_number && (
                                                <p style={{ fontStyle: 'italic', fontWeight: 'bold', color: 'gray' }}>Roll Number: {profileData?.roll_number}</p>
                                            )}
                                            {profileData?.college_name && (
                                                <p style={{ fontStyle: 'italic', fontWeight: 'bold', color: 'gray' }}>College: {profileData?.college_name}</p>
                                            )}
                                            {profileData?.user_last_crawled_at ? (
                                                <p style={{ fontStyle: 'italic', fontWeight: 'bold', color: 'gray' }}>
                                                    Last Crawled At: <TimeAgo date={new Date(profileData?.user_last_crawled_at)} />
                                                </p>
                                            ) : (
                                                <p style={{ fontStyle: 'italic', fontWeight: 'bold', color: 'gray' }}>Last Crawled At: User Set For Crawling</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-8 col-lg-9 card">
                        {/* Timeline */}
                        <div className="timelineClass-For-BodyStyles">
                            <div className="dropdown text-center">
                                <button
                                    className="btn btn-secondary dropdown-toggle w-50 mt-4"
                                    style={{ height: '40px' }}
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    {selectedOption}
                                </button>
                                <ul className="dropdown-menu dropdown-menu-dark w-50">
                                    {sitesOptions.map((option, index) => (
                                        <li key={index}>
                                            <a
                                                className="dropdown-item text-center"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => handleOptionSelect(option)}
                                            >
                                                {option}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="timeline-area">
                                <div className="timeline-container">
                                    <div className="timeline-timelines ">
                                        <h2>UserHandle History</h2>
                                    </div>
                                    <div className="timeline-all-timelines">
                                        {historyData.length === 0 ? (
                                            <div className="timeline-text-nodata">
                                                <h6>| ---- No Data Available ---- |</h6>
                                            </div>
                                        ) : (
                                            historyData?.map((historyObj, idx) => {
                                                return (
                                                    <div className="timeline-single-timeline timeline-d-flex-2" key={idx}>
                                                        <div className="timeline-blank"></div>
                                                        <div className="timeline-text timeline-d-flex-2">
                                                            <span>
                                                                <u>
                                                                    <h6>
                                                                        <strong style={{ color: 'purple',cursor:"pointer",display:"inline" }} onClick={()=>navigate("/profile/"+historyObj?.updatedBy?._id)}>{historyObj?.updatedBy?.name}</strong>  {idx+1<historyData.length?<span style={{display:"inline"}}> updated {selectedOption} handle from <spa style={{color:"green",display:"inline"}}>{historyData[idx+1].site_handle}</spa></span>:<span style={{display:"inline"}}>updated {selectedOption} handle </span>} to{' '}
                                                                        <strong style={{ color: 'green',display:"inline" }}>{historyObj?.site_handle?.toString()}</strong> at{' '}
                                                                        {new Date(historyObj?.updatedAt).toLocaleString('en-US', {
                                                                            year: 'numeric',
                                                                            month: '2-digit',
                                                                            day: '2-digit',
                                                                            hour: '2-digit',
                                                                            minute: '2-digit',
                                                                            second: '2-digit',
                                                                            hour12: true, // Display time in 12-hour format
                                                                        }).replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3')}
                                                                    </h6>
                                                                </u>
                                                            </span>
                                                            <div className="timeline-t-square"></div>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> : <div className="text-center mt-5">
                <FadeLoader color="green" />
            </div>}
        </>
    );
};

export default UserHandleHistory;
